import React, { Component } from "react";
import moment from "moment";
import GaugeChart from "react-gauge-chart";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareXTwitter, faLinkedin, faFacebookSquare } from '@fortawesome/free-brands-svg-icons';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import ProcessingWithDots from "../ProcessingWithDots";

import "./style.css";

class Gauge extends Component {
	state = {
		rangedFlux: null,
		yesterdayFlux: null
	};

	componentDidMount() {
		const { flux, yesterdayFlux } = this.props;
		// Default to 0 if flux is not a number (prevents NaN in gauge calculations)
		const numericFlux = (typeof flux === 'number' && !isNaN(flux)) ? flux : 0;
		const rangedFlux = numericFlux > 10 ? 10 : numericFlux < 1 ? 1 : numericFlux;
		this.setState({ rangedFlux, yesterdayFlux });
	}

	share = (network) => () => {
		const url = encodeURIComponent(
			"https://www.brightlocal.com/free-local-seo-tools/local-rankflux"
		);
		const text = encodeURIComponent("Today’s #LocalRankFlux Score");
		if (network === "twitter") {
			window.open(
				`https://twitter.com/share?url=${url}&text=${text}`,
				"",
				"menubar=no,toolbar=no,height=300,width=600"
			);
		} else if (network === "facebook") {
			window.open(
				`https://www.facebook.com/sharer/sharer.php?u=${url}&t=${text}`,
				"",
				"menubar=no,toolbar=no,height=300,width=600"
			);
		} else if (network === "linkedin") {
			window.open(
				`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${text}`,
				"",
				"menubar=no,toolbar=no,height=300,width=600"
			);
		}
	};

	getArrowClassName(flux, yesterdayFlux) {
		// console.log("DOING ARROW CLASSNAME")
		// Only compare if both values are valid numbers
		if (typeof flux === 'number' && !isNaN(flux) && typeof yesterdayFlux === 'number' && !isNaN(yesterdayFlux)) {
			if (flux > yesterdayFlux) {
				// console.log("flux > yesterdayFlux");
				return "up-arrow";
			} else if (flux < yesterdayFlux) {
				// console.log("flux < yesterdayFlux");
				return "down-arrow";
			}
		}
		return "no-arrow"; // Default if flux equals yesterdayFlux or values are non-numeric
	}

	render() {
		const { day, flux, manualColours } = this.props;
		const { rangedFlux, yesterdayFlux } = this.state;

		// console.log('[Gauge] yesterdayFlux: ', yesterdayFlux);
		// console.log('[Gauge] rangedFlux: ', rangedFlux);
		// console.log('[Gauge] flux: ' , flux);

		let arrowClassName = this.getArrowClassName(flux, yesterdayFlux);

		// console.log("[Gauge] arrowClassName:", arrowClassName);

		const rangeFluxOffset = rangedFlux - 0.1;

		if (rangeFluxOffset === null) {
			return <div>Initializing gauge...</div>;
		}

		const percentValue = rangeFluxOffset / 10;
		const fluxText = flux === "No result" ? "No result" : `${flux} / 10`;
		const _date = moment(day, "YYYY-MM-DD");
		const date = _date.format("MMM Do");
		const dayName = _date.format("ddd").toUpperCase();

		return (
			<div className="bl-gauge">
				<div className="bl-gauge-container">
					<div className="bl-gauge-container1">
						{flux ? (
							<>
								<GaugeChart
									className="rf-gauge-chart-custom"
									needleColor="#097D23"
									needleBaseColor="#097D23"
									text={fluxText}
									id="gauge-chart3"
									nrOfLevels={10}
									colors={manualColours}
									arcWidth={0.35}
									percent={percentValue} // bit of an offset
									textColor={"black"}
									hideText={true} // If you want to hide the text
									marginInPercent={0}
									cornerRadius={5}
									animDelay={0}
									arcPadding={0.02}
									animate={false}
								/>


								<div className="rf-gauge-circle"></div>

							</>
						) : null}


						{!flux ? (
							<div className="bl-rf-globey">
								<img
									src="/wp-content/plugins/wp-local-rankflux/frontend/build/img/globey-bad-citation.png"
									alt="Globey"
									width="640"
									height="320" 
									className="img-respond"
								/>
							</div>
						) : null}
						
						
						
					</div>
					<div className="bl-gauge-container2">
						<div className="bl-gauge-date">
							<div className="day">{dayName}</div>
							<div className="date">{date}</div>
						</div>
						<div
							className={`bl-gauge-score ${arrowClassName}`}
							style={{ backgroundColor: manualColours[Math.floor(flux)] }}
						>
							<div className="score">
								{moment(day, "YYYY-MM-DD").isSame(moment().startOf("day"), "day") ? (
									flux === 'No result' ? (
										<>
											<div className="score-warn" style={{ 
													color: 'red', 
													fontSize:"1.5rem", 
													marginTop:"-2rem" 
											}}><ProcessingWithDots /></div>
											<div className="score-warn-small" style={{ 
													color: '#252525', 
													fontSize:"0.7rem", 
													marginTop:"0.5rem", 
													fontWeight:"500",
													lineHeight:"1.3",
													paddingLeft: "2.5rem",
													paddingRight: "2.5rem" 
											}}>We are still crunching the numbers, please come back later.</div>
										</>
									) : (
										flux // Display the flux value for today if available
									)
								) : flux === 'No result' ? (
									<div>
										<FontAwesomeIcon icon={faCircleExclamation} size="2x" style={{ color: 'red', fontSize: '10px', marginTop: '-2.5rem' }} /> No result
									</div> 
									// Display "No result" for past days. 
								) : (
									flux // Display the flux value for past days
								)}
							</div>
							{flux && flux !== 'No result' && (
								<div className="bl-gauge-social">
									<div className="bl-gauge-social-inner">
										Share this score
										<div className="share">
											<FontAwesomeIcon
												icon={faSquareXTwitter}
												size="1x"
												onClick={this.share("twitter")}
											/>
											<FontAwesomeIcon
												icon={faLinkedin}
												size="1x"
												onClick={this.share("linkedin")}
											/>
											<FontAwesomeIcon
												icon={faFacebookSquare}
												size="1x"
												onClick={this.share("facebook")}
											/>
										</div>
									</div>
								</div>
							)}

						</div>
					</div>
				</div>
				{/* <div className="bl-gauge-social">
					<div className="rf-weekly-chart-button">
						{ {flux ? (
							<a href="#weekly-chart">
								<FontAwesomeIcon
									icon={faChartBar}
								/> View the weekly chart
							</a>
						) : (
							<p>&nbsp;</p>
						)} }
					</div>
				</div> */}
			</div>
		);
	}
}

export default Gauge;

